module.exports = __webpack_public_path__ + "static/media/pdf-icon4.e4a11ddf.png";